var map = {
	"./img_1.jpg": 99590,
	"./img_2.jpg": 62690,
	"./img_3.jpg": 8302,
	"./img_4.jpg": 34905,
	"./img_5.jpg": 70343,
	"./img_6.jpg": 65189,
	"./img_7.jpg": 44720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23689;